

export class PFDto implements IPFDto {
    id!: number | undefined;
    yearMonth!: string | undefined;
    monthDate!: Date;
    fromAmount!: number;
    toAmount!: number;
    epfPer!: number;
    fpfPer!: number;
    account2Per!: number;
    account2Amt!: number;
    account21Per!: number;
    account21Amt!: number;
    account22Per!: number;
    account22Amt!: number;

    constructor(data?: IPFDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.yearMonth = _data["yearMonth"];
            this.monthDate = _data["monthDate"] ? new Date(_data["monthDate"].toString()) : <any>undefined;
            this.fromAmount = _data["fromAmount"];
            this.toAmount = _data["toAmount"];
            this.epfPer = _data["epfPer"];
            this.fpfPer = _data["fpfPer"];
            this.account2Per = _data["account2Per"];
            this.account2Amt = _data["account2Amt"];
            this.account21Per = _data["account21Per"];
            this.account21Amt = _data["account21Amt"];
            this.account22Per = _data["account22Per"];
            this.account22Amt = _data["account22Amt"];
        }
    }

    static fromJS(data: any): PFDto {
        data = typeof data === 'object' ? data : {};
        let result = new PFDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["yearMonth"] = this.yearMonth;
        data["monthDate"] = this.monthDate ? this.monthDate.toISOString() : <any>undefined;
        data["fromAmount"] = this.fromAmount;
        data["toAmount"] = this.toAmount;
        data["epfPer"] = this.epfPer;
        data["fpfPer"] = this.fpfPer;
        data["account2Per"] = this.account2Per;
        data["account2Amt"] = this.account2Amt;
        data["account21Per"] = this.account21Per;
        data["account21Amt"] = this.account21Amt;
        data["account22Per"] = this.account22Per;
        data["account22Amt"] = this.account22Amt;
        return data; 
    }
}

export interface IPFDto {
    id: number | undefined;
    yearMonth: string | undefined;
    monthDate: Date;
    fromAmount: number;
    toAmount: number;
    epfPer: number;
    fpfPer: number;
    account2Per: number;
    account2Amt: number;
    account21Per: number;
    account21Amt: number;
    account22Per: number;
    account22Amt: number;
}

